/**
 * Aquest module serveix per a fer un login per AJAX, tant per al client
 * com per a familiars de les llistes.
 * Requereix:
 * - Un contenidor amb la classe "component-login-client", amb data:
 *     - submit-url: string, URL a on enviar la petició.
 *     - login-incorrect-msg: string, missatge de que no
 *     - login_success-msg: string, missatge de que sí
 *     - disabled-class: classe a afegir al contenidor i al form quan es vol
 *       desactivar el formulari (mentres s'espera resposta del servidor).
 * - Un formulari a dins amb els següents elements:
 *     - "username": input tipus text
 *     - "password": input tipus password
 *     - input o  type "submit"
 * - Un contenidor per als missatges amb class="login-message".
 */

import axios from 'axios';

/* Assumed jQuery */
const $ = window.jQuery;

/* Init */

/**
 * Included in default export object
 * @return void
 */
function init ()
{
    /* Search for login components */
    $('.component-login-client').each( function (event) {
        initOne($(this));
    });

    if ($('#enter-client-list-btn').length) {
        $('#enter-client-list-btn').on('click', setupClickLlistaBtn);
    }
}

/**
 * @param object $container jQuery element
 * @return void
 */
function initOne ($container)
{
    /* jQuery elements */
    const jqForm = $container.find('form');
    const jqInputUsername = $container.find('*[name="username"]');
    const jqInputPassword = $container.find('*[name="password"]');
    const jqButtonSubmit = $container.find('*[type="submit"]');
    const jqMessage = $container.find('.login-message');

    /* Data from elements */
    const submitUrl = $container.data('submit-url');
    let successUrl = $container.data('success-url');
    const clientMode = $container.data('client-mode');
    const loginIncorrectMsg = $container.data('login-incorrect-msg');
    const loginSuccessMsg = $container.data('login-success-msg');
    const disabledClass = $container.data('disabled-class')

    /* Define event handler on submit */
    function onSubmit (event) {
        event.preventDefault();
        jqMessage.removeClass('success').hide().html('');
        $container.addClass(disabledClass);
        jqForm.addClass(disabledClass);
        jqButtonSubmit.blur();
        const query = {
            username: jqInputUsername.val(),
            password: jqInputPassword.val(),
            client_mode: clientMode,
        }

        const buttonClicked = document.querySelector("#clickButton");

        if (buttonClicked && buttonClicked.value === "enter-client-list-btn") {
            successUrl = $container.data('success-url-lista');
        }

        axios.post(submitUrl, query)
            .then((response) => {
                if (response.data.success) {
                    loginSuccess();
                } else {
                    loginError();
                }
            })
            .catch((error) => {
                loginError();
            });
    }

    function loginSuccess ()
    {
        jqMessage.addClass('success').show().html(loginSuccessMsg);
        if (successUrl) {
            location.href = successUrl;
        } else {
            location.reload ();
        }
    }

    function loginError ()
    {
        jqMessage.show().html(loginIncorrectMsg);
        $container.removeClass(disabledClass);
        jqForm.removeClass(disabledClass);
    }

    /* Declare event on submit */
    jqForm.on('submit', onSubmit);

}

function setupClickLlistaBtn(){
    document.querySelector("#clickButton").value = "enter-client-list-btn";
}

/* Export object with public props */
export default {
    init,
};
